import React from 'react'
import { useSelector } from 'react-redux'
import { node } from 'prop-types'
import Container from '@components/Container'

import { Logo } from '@assets/logos'

import * as Style from './Appbar.style'

export default function Appbar({ children }) {
  const { country } = useSelector(store => store.application)

  const redirectToLandingPage = `https://site.gympass.com/web/${country}/digital`

  return (
    <Style.Wrapper>
      <Container>
        <Style.Content>
          <a href={redirectToLandingPage}>
            <Style.Logo src={Logo} alt="Gympass (logo) written in orange" />
          </a>

          <Style.ContentRight>{children}</Style.ContentRight>
        </Style.Content>
      </Container>
    </Style.Wrapper>
  )
}

Appbar.propTypes = {
  children: node,
}

Appbar.defaultProps = {
  children: undefined,
}
